import { Stack } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import ExamProgressLegend from "../../components/ExamProgressLegend";
import LearningPathStudentsProgressesTable from "../../components/tables/StudentsTable";
import useGetLearningPathDetails from "../../hooks/api/learning-path/useGetLearningPathDetails";
import useGetLearningPathStudentsProgresses from "../../hooks/api/learning-path/useGetLearningPathStudentsProgresses";
import BasePage from "../common/BasePage";

type LocationState = {
  learningPathId: string;
};

export default function LearningPathProgressesPage() {
  const {
    state: { learningPathId },
  } = useLocation() as { state: LocationState };
  const {
    data: learningPath,
    isLoading: isLearningPathLoading,
    isError: hasLearningPathError,
    refetch: refetchLearningPath,
  } = useGetLearningPathDetails(learningPathId);
  const {
    data: studentsProgresses,
    isPending,
    isError,
    mutateAsync: fetchStudentsProgresses,
  } = useGetLearningPathStudentsProgresses(learningPathId);

  return (
    <BasePage
      title={learningPath?.name}
      isLoading={isLearningPathLoading}
      hasError={hasLearningPathError}
      retry={refetchLearningPath}
    >
      <LearningPathStudentsProgressesTable
        learningPath={learningPath!}
        progresses={studentsProgresses?.content ?? []}
        isLoading={isPending}
        isError={isError}
        pagination={studentsProgresses?.page}
        refetch={fetchStudentsProgresses}
      />
      <Stack alignItems="flex-end">
        <ExamProgressLegend />
      </Stack>
    </BasePage>
  );
}
